import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const retailerCardCustomersSlice = createSlice({
    name: "retailerCardCustomers",
    initialState: {
        page: 0,
        pageCount: 0,
        listData: null,
        totalUniqueCustomers: 0,
        customerCardDetail: null,
        customerCardDetailLoading: false,
    },
    reducers: {
        doGetRetailerCardCustomersListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
            state.pageCount = action.payload?.page_count;
            state.totalUniqueCustomers = action.payload?.total_unique_customers || 0;
        },
        doGetRetailerCardCustomersListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
            state.totalUniqueCustomers = 0;
        },
        doGetRetailerCardCustomerDetailStart: (state) => {
            state.customerCardDetailLoading = true;
        },
        doGetRetailerCardCustomerDetailSuccess: (state, action) => {
            state.customerCardDetail = action.payload.data;
            state.customerCardDetailLoading = false;
        },
        doGetRetailerCardCustomerDetailFail: (state, action) => {
            state.customerCardDetail = null;
            state.customerCardDetailLoading = false;
        },
        resetRetailerCardCustomersState: (state) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
            state.totalUniqueCustomers = 0;
            state.customerCardDetail = null;
            state.customerCardDetailLoading = false;
        },
    },
});

export const doGetRetailerCardCustomersList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/retail-management/${param.retailer_id}/card-customers?page=${param.page}&size=${param.limit}`;
        if (param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetRetailerCardCustomersListSuccess(response.data));
    } catch (error) {
        dispatch(doGetRetailerCardCustomersListFail(error.response));
    }
};

export const doGetRetailerCardCustomerDetail = (param) => async (dispatch) => {
    try {
        dispatch(doGetRetailerCardCustomerDetailStart());
        const url = `/api/admin/retail-management/${param.retailer_id}/card-customers/${param.customer_id}`;

        const response = await axios.get(url);
        dispatch(doGetRetailerCardCustomerDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetRetailerCardCustomerDetailFail(error.response));
    }
};

export const {
    doGetRetailerCardCustomersListSuccess,
    doGetRetailerCardCustomersListFail,
    doGetRetailerCardCustomerDetailStart,
    doGetRetailerCardCustomerDetailSuccess,
    doGetRetailerCardCustomerDetailFail,
    resetRetailerCardCustomersState,
} = retailerCardCustomersSlice.actions;

export const getRetailerCardCustomersList = (state) => state.retailerCardCustomers?.listData;
export const getRetailerCardCustomersPage = (state) => state.retailerCardCustomers?.page;
export const getRetailerCardCustomersPageCount = (state) => state.retailerCardCustomers?.pageCount;
export const getRetailerCardCustomersTotalUnique = (state) => state.retailerCardCustomers?.totalUniqueCustomers;
export const getRetailerCardCustomerDetail = (state) => state.retailerCardCustomers?.customerCardDetail;
export const getRetailerCardCustomerDetailLoading = (state) => state.retailerCardCustomers?.customerCardDetailLoading;

export default retailerCardCustomersSlice.reducer;
